// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Gq9nmwJx0VYX6AVJd3dl{border-bottom:1px solid var(--border-neutral-primary);justify-content:space-between;align-items:center;display:flex}.Gq9nmwJx0VYX6AVJd3dl ._tFyv5auNkrjIQKcceva{align-items:center;gap:8px;width:100%;display:flex}.Gq9nmwJx0VYX6AVJd3dl .PBnWkOE9MegdMq24N2Ci{flex:1;align-items:center;gap:9px;padding:12px 12px 14px 6px}.Gq9nmwJx0VYX6AVJd3dl .PBnWkOE9MegdMq24N2Ci input{height:32px;font-size:16px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"searchWrapper": `Gq9nmwJx0VYX6AVJd3dl`,
	"searchInputWrap": `_tFyv5auNkrjIQKcceva`,
	"textField": `PBnWkOE9MegdMq24N2Ci`
};
export default ___CSS_LOADER_EXPORT___;
